//演講報名表
class SpeechForm {
  constructor(){
    this.window     = $(window);
    this.header     = $('header');
    this.speechForm = $('#speechForm');
    this.footerAds  = $('#footerAds');
    this.footer     = $('footer');
  }
  rwdHeight() {
    let fullScreenHeight = this.window.height() - this.header.outerHeight();
    this.speechForm.css('height', fullScreenHeight);
  }
  form(){
    this.rwdHeight();
    this.window.on('resize', () => {
      this.rwdHeight();
    });
    this.footerAds.hide();
    this.footer.hide();
  }
}




//輸出
export {SpeechForm};


// WEBPACK FOOTER //
// ./js_new/speech_form.js